var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oidcIsAuthenticated)?_c('div',{staticClass:"editProfile"},[_c('h1',[_vm._v("Edit My Profile")]),_c('h2',[_vm._v("Change First Name")]),_c('ChangeFirstName'),_c('h2',[_vm._v("Change Last Name")]),_c('ChangeLastName')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }